import styled from "styled-components";
import PECCERTIFICATE from "../../assets/images/peccertificate.png";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 100px;
`;
export const Frame = styled.div`
  height: 677px;
  width: 448px;
  border: 20px solid black;
  text-align: center;
  margin: 0 auto;
  background: transparent url("img/Layer frames2.png") 0% 0% no-repeat
    padding-box;
  opacity: 1;
  margin-top: 100px;
  box-shadow: 10px -7px 23px darkgrey, grey 0px 0px 15px inset;
  box-sizing: border-box;
  margin-bottom: 40px;
  img {
    height: 635px;
    width: 400px;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const SpecializationContainer = styled.div`
  width: 90%;
  height: auto;
  margin: 30px auto;
  box-shadow: 2px 3px 8px #00000029;
  border-radius: 10px;
  opacity: 1;
  padding: 59px 108px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

export const NameContainer = styled.td`
  border-right: 1px dashed #f08700;
  padding-top: 10px;

  vertical-align: top;
  padding-right: 108px;
  vertical-align: top;

  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 30px;
  }
`;

export const NamesBtn = styled.div`
  border-radius: 5px;
  width: 72px;
  height: 39px;
  box-shadow: 2px 3px 8px #00000029;
  margin-bottom: 60px;
  font-size: 28px;
  font-family: Poppins-Medium;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
`;

export const SpecializationNames = styled.div`
  height: 20px;
  color: #f08700;
  font-size: 28px;
`;
export const DescriptionContainer = styled.td`
  padding-top: 10px;
  padding-left: 108px;
  vertical-align: top;

  @media (max-width: 768px) {
    padding-left: 20px;
  }
`;

export const Description = styled.div`
  width: 100%;
  margin-bottom: 25px;
  font-size: 25px;
  font-family: Poppins-Light;
`;

export const CertificatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 320px;
  margin: 0 auto;
  flex: 20%;
  flex-wrap: wrap;
  gap: 10%;
  justify-content: center;
  margin-bottom: 50px;
  margin: 100px;

  @media (max-width: 1024px) {
    gap: 5%;
    margin-top: 150px;
  }

  @media (max-width: 768px) {
    gap: 2%;
    margin-top: 50px;
  }
`;
export const Title = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  text-align: center;
  color: #1d1d1d;
  padding-top: 60px;
  margin: 0;
`;

export const CertificatesFrame = styled.div`
  height: 330px;
  width: 280px;
  border: 15px solid black;
  background: transparent url("img/Layer frames2.png") 0% 0% no-repeat
    padding-box;
  opacity: 1;
  margin-top: 100px;
  box-shadow: 10px -7px 23px darkgrey, grey 0px 0px 15px inset;
  box-sizing: border-box;
  margin-bottom: 40px;
`;

export const ImageContainer = styled.img``;
